import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { Employee } from "~/providers/employee-provider";

interface EmployeeStoreState {
  profileOpen: boolean;
  selectedEmployee?: Employee;
  signInOpen: boolean;
  employeeDialogOpen: boolean;
  setSelectedEmployee: (selectedEmployee?: Employee) => void;
  setEmployeeDialogOpen: (open: boolean) => void;
  setProfileOpen: (profileOpen: boolean) => void;
}

export const useEmployeeStore = create<EmployeeStoreState>()(
  devtools((set) => ({
    employeeDialogOpen: false,
    noPermissionOpen: false,
    profileOpen: false,
    signInResolver: null, // Store for the sign-in promise resolvers
    signInOpen: false,
    setEmployeeDialogOpen(open) {
      set(() => ({ employeeDialogOpen: open }));
    },
    setSelectedEmployee(employee) {
      set(() => ({ selectedEmployee: employee }));
    },
    setProfileOpen: (profileOpen) => set({ profileOpen }),
  })),
);
